import React from 'react';
import { FormattedMessage } from 'react-intl';
import Tooltip from 'react-tooltip-component';

export default class RadioButton extends React.Component {
  render() {
    return (
      <div className="pickupTimeOption">
        <input
          id={this.props.value}
          className="pickupTimeRadio"
          type="radio"
          name="radio-option"
          value={this.props.value}
          onClick={this.props.handleRadioChange}
          defaultChecked={this.props.selected}
        />
        <Tooltip title={this.props.toolTipTitle} position="right">
          <label htmlFor={this.props.value}>
            <span>
              <span />
            </span>
            <label>
              <FormattedMessage
                id={this.props.message.id}
                defaultMessage={this.props.message.default}
              />
            </label>
          </label>
        </Tooltip>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/checkout/components/RadioButton.jsx